import { render, staticRenderFns } from "./detailPaymentInfo.vue?vue&type=template&id=2ea91cc1"
import script from "./detailPaymentInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./detailPaymentInfo.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports